/**
 * 节流工具函数
 * 从 sheep/helper/throttle.js 转换
 */

let timer: ReturnType<typeof setTimeout> | null = null
let flag = false

/**
 * 节流原理：在一定时间内，只能触发一次
 * 
 * @param func 要执行的回调函数
 * @param wait 延时的时间，默认 500ms
 * @param immediate 是否立即执行，默认 true
 */
function throttle<T extends (...args: any[]) => void>(
  func: T,
  wait = 500,
  immediate = true
): void {
  if (immediate) {
    if (!flag) {
      flag = true
      // 如果是立即执行，则在 wait 毫秒内开始时执行
      typeof func === 'function' && func()
      timer = setTimeout(() => {
        flag = false
      }, wait)
    }
  } else if (!flag) {
    flag = true
    // 如果是非立即执行，则在 wait 毫秒内的结束处执行
    timer = setTimeout(() => {
      flag = false
      typeof func === 'function' && func()
    }, wait)
  }
}

/**
 * 带返回值的节流函数（用于需要获取返回值的场景）
 * 
 * @param func 要执行的回调函数
 * @param wait 延时的时间，默认 500ms
 * @param immediate 是否立即执行，默认 true
 * @returns 节流后的函数
 */
export function throttleFn<T extends (...args: any[]) => any>(
  func: T,
  wait = 500,
  immediate = true
): (...args: Parameters<T>) => ReturnType<T> | undefined {
  let timer: ReturnType<typeof setTimeout> | null = null
  let flag = false
  let result: ReturnType<T> | undefined

  return function (...args: Parameters<T>): ReturnType<T> | undefined {
    if (immediate) {
      if (!flag) {
        flag = true
        result = func(...args)
        timer = setTimeout(() => {
          flag = false
        }, wait)
      }
    } else if (!flag) {
      flag = true
      timer = setTimeout(() => {
        flag = false
        result = func(...args)
      }, wait)
    }
    return result
  }
}

export default throttle
